import React from 'react'
import { useReactFlow } from '@xyflow/react'
import { PREFIX_OF_TEMP_NODE } from '../constant'

const X_OFFSET_OF_CLONE_NODE = 200

export default function useNodeCRUD() {

    const { setNodes, getNodes, deleteElements } = useReactFlow()

    /**
     * clone a node
     * @param {Event} e event
     * @param {String} id node id
     */
    const onNodeClone = (e, id) => {
        e.preventDefault()

        const cloneTarget = getNodes().filter(node => node?.id == id)

        const newNode = {
            ...cloneTarget?.[0],
            id: `${PREFIX_OF_TEMP_NODE}${Date.now().toString()}`,
            selected: false,
            position: {
                x: cloneTarget?.[0]?.position.x + X_OFFSET_OF_CLONE_NODE,
                y: cloneTarget?.[0]?.position.y,
            },
            data: {
                ...cloneTarget?.[0]?.data,
                id: `${PREFIX_OF_TEMP_NODE}${Date.now().toString()}`,
            }
        }

        setNodes(nds => nds.concat(newNode))
    }

    /**
     * delete a node
     * @param {String} id node id
     */
    const onNodeDelete = (id) => {
        deleteElements({ nodes: [{ id }], edges: [{ id }] })
    }

    return {
        onNodeClone,
        onNodeDelete
    }
}
